module.exports = __webpack_public_path__ + "img/scribble-green.7ae2c07c.svg";